export default __webpack_public_path__ + "static/landing-page-bg-e0b6ef414ba285287092666f4cd35d10.jpg";